import React from 'react'
import { createUseStyles, useTheme } from 'react-jss'
import DataExtractionIcon, { extractionStatuses } from './DataExtractionIcon'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    alignItems: 'right',
  },
  label: {
    paddingRight: '1rem',
    fontStyle: 'italic',
  },
  icon: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  },
})

export default function DataExtractionReference() {
  const theme = useTheme()
  const classes = useStyles({ theme })

  return (
    <div className={classes.container}>
      <span className={classes.label}>Parsing Reference</span>
      <span className={classes.icon}>
        <DataExtractionIcon
          extractionStatus={extractionStatuses.NOT_STARTED}
          showLabel
        />
      </span>
      <span className={classes.icon}>
        <DataExtractionIcon
          extractionStatus={extractionStatuses.REQUESTED}
          showLabel
        />
      </span>
      <span className={classes.icon}>
        <DataExtractionIcon
          extractionStatus={extractionStatuses.COMPLETED}
          showLabel
        />
      </span>
      <span className={classes.icon}>
        <DataExtractionIcon
          extractionStatus={extractionStatuses.FAILED}
          showLabel
        />
      </span>
    </div>
  )
}
